<!-- 小程序公共页 -->
<template>
  <div>
    <a-page-header
      :title="this.$route.meta.title"
      :sub-title="this.$route.meta.subTitle"
      @back="this.goBack"
      class="vd-gl-header-warp"
    >
      <template slot="extra">
        <template v-if="$AuthUtil.authRoute('/program/edit')">
          <a-button type="primary" icon="setting" @click="change">
            设置
          </a-button>
        </template>
      </template>
      <template slot="footer">
        <a-tabs :default-active-key="$route.path" @change="changePane">
          <!--          <a-tab-pane v-show="$AuthUtil.authRoute('/program/detail/statistical')"-->
          <!--                      key="/program/detail/statistical"-->
          <!--                      tab="数据展示"/>-->
          <a-tab-pane key="/blog/detail/month" tab="月报"></a-tab-pane>
          <a-tab-pane key="/blog/detail/daily" tab="每日数据"></a-tab-pane>
          <a-tab-pane key="/blog/detail/qr_code" tab="二维码功能"></a-tab-pane>
          <a-tab-pane key="/blog/detail/menu" tab="菜单功能"></a-tab-pane>
        </a-tabs>
      </template>
      <a-descriptions size="small" :column="1">
        <a-descriptions-item label="小程序id">
          {{ id }}
          <a-tag @click="copy(id)" class="vd-gl-copy">
            <a-icon type="copy" />
            复制
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="公众号名称">
          {{ detail.nickname }}
        </a-descriptions-item>
      </a-descriptions>

      <div class="vd-gl-statistic-group">
        <!-- 小程序状态 -->
        <a-statistic
          title="小程序状态"
          :value="detail.status === 1 ? '推广中' : '推广结束'"
          class="vd-gl-statistic"
        />
        <!-- 推广员数量 -->
        <a-statistic
          title="推广员"
          :value="detail.activity_num"
          class="vd-gl-statistic"
        >
          <template slot="prefix">
            <a-icon type="user"></a-icon>
          </template>
        </a-statistic>
        <!-- 推广总量 -->
        <a-statistic
          title="推广量"
          :value="detail.activity_count"
          class="vd-gl-statistic"
        />
      </div>
    </a-page-header>

    <div class="vd-gl-content">
      <router-view />
    </div>

    <a-modal
      v-model="visible"
      title="修改小程序"
      ok-text="确认"
      cancel-text="取消"
      @ok="confirm"
      @cancel="cancel"
      :confirm-loading="confirmLoading"
    >
      <a-form-model
        ref="ruleForm"
        layout="horizontal"
        :model="detail"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="小程序名" ref="name" prop="name">
          <a-input
            class="vd-input-s"
            v-model="detail.name"
            placeholder="小程序名称"
          />
          <span class="common-mute"> {{ detail.name.length }}/30</span>
        </a-form-model-item>
        <a-form-model-item label="AppID" prop="app_id">
          <a-input
            class="vd-input-s"
            v-model="detail.app_id"
            placeholder="小程序唯一凭证"
          />
        </a-form-model-item>
        <a-form-model-item label="SecretID" prop="secret_id">
          <a-input
            class="vd-input-m"
            v-model="detail.secret_id"
            placeholder="小程序唯一凭证密钥"
          />
        </a-form-model-item>
        <a-form-model-item label="CRM 表单Sid" prop="sid">
          <a-input
            class="vd-input-m"
            v-model="detail.sid"
            placeholder="活动表单的推送sid"
          />
        </a-form-model-item>
        <a-form-model-item label="备注" prop="description">
          <a-textarea
            class="vd-input-s"
            v-model="detail.description"
            placeholder="备注,字符限制60"
            :rows="3"
          ></a-textarea>
          <span class="common-mute"> {{ detail.description.length }}/60</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import $HelperUtil from "@/utils/helper";
import { blog_detail } from "@/api/blog";

export default {
  name: "detail",
  data() {
    return {
      //modal
      confirmLoading: false,
      visible: false,
      //form
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      switchStatus: true,
      // data
      id: null,
      detail: {
        add_time: 1600045345,
        nickname: "-",
        secret_id: "-",
        sid: "-",
        description: "-",
        name: "-",
        status: 1,
        upd_time: 1600050274,
        activity_num: 0,
        activity_count: 0,
      },
      old_detail: {},
      rules: {
        name: [
          { required: true, message: "请输入小程序名称", trigger: "blur" },
          { min: 3, max: 25, message: "小程序名称长度3-25", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择小程序所属项目", trigger: "blur" },
        ],
        status: [
          {
            required: true,
            message: "请选择小程序所属项目",
            trigger: "change",
          },
        ],
        appId: [
          { required: true, message: "请输入小程序appId", trigger: "blur" },
        ],
        appSecret: [
          {
            required: true,
            message: "请输入小程序secretId",
            trigger: "change",
          },
        ],
        description: [
          {
            min: 0,
            max: 60,
            message: "备注长度不要超过60个字符",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    /* 获取参数*/
    this.id = this.$route.query.id;
    if (!this.id) {
      this.$message.error({ content: "访问参数错误" });
      // 链接回跳
      this.$router.push({ path: "/blog/setting", replace: true });
      return false;
    }
    this.getData();
  },
  methods: {
    // modal
    change() {
      this.visible = !this.visible;
    },
    confirm() {
      this.confirmLoading = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(111);
        } else {
          setTimeout(() => {
            this.confirmLoading = false;
          }, 1000);
          return false;
        }
      });
    },
    cancel() {
      this.detail = $HelperUtil.deepClone(this.old_detail);
    },
    // 获取详细信息
    getData() {
      blog_detail({ id: this.id }).then((res) => {
        if (res.code === 1) {
          this.detail.nickname = res.list.nickname;
          // this.detail.add_time
          // this.detail.add_time
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    copy(copy_text) {
      let clipboard = new Clipboard(".vd-gl-copy", {
        text: function() {
          return copy_text;
        },
      });
      clipboard.on("success", () => {
        this.$message.success({ content: "复制成功", duration: 1 });
        // 释放内存
        clipboard.destroy();
      });
    },
    // 跳转
    changePane(value) {
      // 判断参数是否正确
      if (this.id) {
        this.$router.replace({ path: value, query: { id: this.id } });
      } else {
        this.$message.error({ content: "访问参数错误" });
        // 链接回跳
        this.$router.replace({ path: "/blog/setting", replace: true });
        return false;
      }
    },
  },
};
</script>

<style scoped>
.no-warp {
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}
</style>
